import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useLocation, Link } from 'react-router-dom';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./ShoppingList.css";

// Social media links data
const socialMediaLinks = [
  { id: 1, name: 'Facebook', icon: 'icon-fb', link: '#' },
  { id: 2, name: 'Twitter', icon: 'icon-Icon-x', link: '#' },
  { id: 3, name: 'Instagram', icon: 'icon-instagram', link: '#' },
  { id: 4, name: 'TikTok', icon: 'icon-tiktok', link: '#' },
  { id: 5, name: 'Pinterest', icon: 'icon-pinterest-1', link: '#' },
];

// Reusable Sidebar Content Component
const SidebarContent = ({ categoryTree, handleCategoryToggle, selectAllCategories, deselectAllCategories, selectedCategories }) => {
  return (
    <div className="tf-shop-sidebar-content">
      <div className="widget-facet wd-categories">
        <div className="facet-title" data-bs-target="#categories" data-bs-toggle="collapse" aria-expanded="true" aria-controls="categories">
          <span>Product categories</span>
          <span className="icon icon-arrow-up"></span>
        </div>
        <div id="categories" className="collapse show">
          <div className="category-filter-actions">
            <button onClick={selectAllCategories}>Select All</button>
            <button onClick={deselectAllCategories}>Deselect All</button>
          </div>
          <CategoryTree 
            categories={categoryTree} 
            onToggle={handleCategoryToggle}
          />
          <div className="selected-count">
            {selectedCategories.length} categories selected
          </div>
        </div>
      </div>
      {/* <div className="widget-facet">
        <div className="facet-title" data-bs-target="#follow" data-bs-toggle="collapse" aria-expanded="true" aria-controls="follow">
          <span>Follow us</span>
          <span className="icon icon-arrow-up"></span>
        </div>
        <div id="follow" className="collapse show">
          <ul className="tf-social-icon d-flex gap-10">
            {socialMediaLinks.map((link) => (
              <li key={link.id}>
                <a href={link.link} className={`box-icon w_34 round bg_line social-${link.name.toLowerCase()}`}>
                  <i className={`icon fs-14 ${link.icon}`} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div> */}
    </div>
  );
};

// Recursive component for displaying category tree with checkboxes on right
const CategoryTree = ({ categories, onToggle, depth = 0 }) => {
  const [expandedCategories, setExpandedCategories] = useState({});

  const toggleExpand = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const toggleCategoryAndChildren = (category, isChecked) => {
    const toggleRecursive = (cat) => {
      cat.isChecked = isChecked;
      if (cat.children) {
        cat.children.forEach(toggleRecursive);
      }
    };
    
    toggleRecursive(category);
    onToggle(category);
  };

  return (
    <ul className="category-tree" style={{ paddingLeft: `${depth * 15}px` }}>
      {categories.map((category) => (
        <li key={category.categoryId}>
          <div className="category-item flex items-center">
            {category.children && category.children.length > 0 ? (
              <span 
                className={`expand-icon w-4 h-4 flex items-center justify-center cursor-pointer mr-2 ${expandedCategories[category.categoryId] ? 'expanded' : ''}`}
                onClick={() => toggleExpand(category.categoryId)}
              >
                {/* {expandedCategories[category.categoryId] ? '▼' : '►'} */}
                {expandedCategories[category.categoryId] ? <FontAwesomeIcon icon={faCaretRight} size='lg'></FontAwesomeIcon>:<FontAwesomeIcon icon={faCaretRight} size='lg'></FontAwesomeIcon>}
              </span>
            ) : (
              <span className="w-4 h-4 mr-2" /> // Placeholder for alignment
            )}
            <input
              type="checkbox"
              checked={category.isChecked}
              onChange={(e) => toggleCategoryAndChildren(category, e.target.checked)}
              className="category-checkbox mr-2"
            />
            <span 
              className="category-name cursor-pointer flex-grow"
              onClick={() => category.children && category.children.length > 0 && toggleExpand(category.categoryId)}
            >
              {category.name}
            </span>
          </div>
          {category.children && category.children.length > 0 && expandedCategories[category.categoryId] && (
            <CategoryTree 
              categories={category.children} 
              onToggle={onToggle}
              depth={depth + 1}
            />
          )}
        </li>
      ))}
    </ul>
  );
};

// Reusable Pagination Component
const Pagination = ({ currentPage, totalPages, handlePageChange }) => {
  const getPaginationRange = () => {
    const maxPagesToShow = 5;
    let startPage, endPage;

    if (totalPages <= maxPagesToShow) {
      startPage = 1;
      endPage = totalPages;
    } else {
      const halfPagesToShow = Math.floor(maxPagesToShow / 2);
      
      if (currentPage <= halfPagesToShow + 1) {
        startPage = 1;
        endPage = maxPagesToShow;
      } else if (currentPage + halfPagesToShow >= totalPages) {
        startPage = totalPages - maxPagesToShow + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - halfPagesToShow;
        endPage = currentPage + halfPagesToShow;
      }
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };

  return (
    <div className="pagination-wrapper">
      <ul className="tf-pagination-wrap tf-pagination-list">
        {/* First Page */}
        <li className={currentPage === 1 ? "disabled" : ""}>
          <a
            href="#"
            className="pagination-link"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(1);
            }}
          >
            First
          </a>
        </li>
        {/* Previous Page */}
        <li className={currentPage === 1 ? "disabled" : ""}>
          <a
            href="#"
            className="pagination-link"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(currentPage - 1);
            }}
          >
            «
          </a>
        </li>
        {/* Page Numbers */}
        {getPaginationRange().map((page) => (
          <li
            key={page}
            className={currentPage === page ? "active" : ""}
          >
            <a
              href="#"
              className="pagination-link"
              onClick={(e) => {
                e.preventDefault();
                handlePageChange(page);
              }}
            >
              {page}
            </a>
          </li>
        ))}
        {/* Next Page */}
        <li className={currentPage === totalPages ? "disabled" : ""}>
          <a
            href="#"
            className="pagination-link"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(currentPage + 1);
            }}
          >
            »
          </a>
        </li>
        {/* Last Page */}
        <li className={currentPage === totalPages ? "disabled" : ""}>
          <a
            href="#"
            className="pagination-link"
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(totalPages);
            }}
          >
            Last
          </a>
        </li>
      </ul>
    </div>
  );
};

function ShoppingList() {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const publicUrl = process.env.PUBLIC_URL;
  const location = useLocation();
  const [categoryTree, setCategoryTree] = useState([]);
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50); // Default to 50
  const [sortOrder, setSortOrder] = useState("Featured");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Helper function to get all descendant category IDs
  const getAllDescendantIds = (categories, categoryId) => {
    const ids = [categoryId];
    const children = categories.filter(cat => cat.parentCategoryId === categoryId);
    children.forEach(child => {
      ids.push(...getAllDescendantIds(categories, child.categoryId));
    });
    return ids;
  };

  // Helper function to get all category IDs (including descendants) from a category tree
  const getAllCategoryIds = (categories) => {
    const ids = [];
    categories.forEach(category => {
      ids.push(category.categoryId);
      if (category.children && category.children.length > 0) {
        ids.push(...getAllCategoryIds(category.children));
      }
    });
    return ids;
  };

  useEffect(() => {
    if (window.initSwitchLayout) {
      window.initSwitchLayout();
      fetchCategories();
      fetchProducts();
    }
    const params = new URLSearchParams(location.search);
    const searchParam = params.get('search');
    setSearchTerm(searchParam || "");
  }, [location.search]);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/categories/GetAllActiveCategories`);
      const allCategories = response.data;
      const params = new URLSearchParams(location.search);
      const categoryIdParam = params.get('categoryId');
      const selectedCategoryId = categoryIdParam ? parseInt(categoryIdParam) : null;

      // Get all descendant IDs if a category is selected
      const selectedDescendantIds = selectedCategoryId ? getAllDescendantIds(allCategories, selectedCategoryId) : [];

      const buildCategoryTree = (categories, parentId = null) => {
        return categories
          .filter(category => category.parentCategoryId === parentId)
          .map(category => ({
            ...category,
            imageSource: `${publicUrl}/${category.imageSource}`,
            children: buildCategoryTree(categories, category.categoryId),
            isChecked: selectedCategoryId ? selectedDescendantIds.includes(category.categoryId) : true
          }));
      };
      
      const categoriesWithChildren = buildCategoryTree(allCategories);
      setCategoryTree(categoriesWithChildren);

      // Set selected categories based on URL
      if (selectedCategoryId) {
        setSelectedCategories(selectedDescendantIds);
      } else {
        // If no categoryId, select all categories (including descendants)
        const allCategoryIds = getAllCategoryIds(categoriesWithChildren);
        setSelectedCategories(allCategoryIds);
      }
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("Error fetching categories:", error);
      }
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/Product/GetAllActiveProducts`);
      let products = response.data.map((product) => ({
        ...product,
        images: product.productImages.map((image) => `${publicUrl}/${image.imageSource}`),
        price: parseFloat(product.price || 0),
        basePrice: parseFloat(product.basePrice || 0),
        totalPrice: parseFloat(product.totalPrice || 0),
        discount: parseFloat(product.discount || 0),
        discountAmount: parseFloat(product.discountAmount || 0),
        gst: parseFloat(product.gst || 0),
        gstAmountAfterDiscount: parseFloat(product.gstAmountAfterDiscount || 0),
        gstAmount: parseFloat(product.gstAmount || 0),
        rateOfPiece: product.rateOfPiece,
        gstIncluded: product.gstIncluded,
      }));
      setProducts(products);
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("Error fetching products:", error);
      }
    }
  };

  const filterProductsBySearch = (products) => {
    if (!searchTerm) return products;
    const term = searchTerm.toLowerCase();
    return products.filter(product => 
      product.name.toLowerCase().includes(term) ||
      (product.description && product.description.toLowerCase().includes(term))
    );
  };

  const sortProducts = (products, order) => {
    switch (order) {
      case "Price, low to high":
        return [...products].sort((a, b) => (a.basePrice - (a.basePrice * (a.discount/100))) - (b.basePrice - (b.basePrice * (b.discount/100))));
      case "Price, high to low":
        return [...products].sort((a, b) => (b.basePrice - (b.basePrice * (b.discount/100))) - (a.basePrice - (a.basePrice * (a.discount/100))));
      case "Alphabetically, A-Z":
        return [...products].sort((a, b) => a.name.localeCompare(b.name));
      case "Alphabetically, Z-A":
        return [...products].sort((a, b) => b.name.localeCompare(a.name));
      default:
        return products;
    }
  };

  const filterProductsByCategory = (products) => {
    if (selectedCategories.length === 0) return [];
    return products.filter(product => selectedCategories.includes(product.categoryId));
  };

  const filteredAndSortedProducts = sortProducts(
    filterProductsBySearch(
      filterProductsByCategory(products)
    ), 
    sortOrder
  );

  const totalPages = Math.ceil(filteredAndSortedProducts.length / recordsPerPage);

  const currentRecords = filteredAndSortedProducts.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top on page change
    }
  };

  const handleRecordsPerPageChange = (e) => {
    const newRecordsPerPage = parseInt(e.target.value);
    setRecordsPerPage(newRecordsPerPage);
    setCurrentPage(1); // Reset to page 1 when changing records per page
  };
  
  const handleSort = (order) => {
    setSortOrder(order);
    setCurrentPage(1);
  };

  const handleCategoryToggle = (category) => {
    const getCategoryIds = (cat) => {
      let ids = [cat.categoryId];
      if (cat.children) {
        cat.children.forEach(child => {
          ids = [...ids, ...getCategoryIds(child)];
        });
      }
      return ids;
    };
    
    if (category.isChecked) {
      setSelectedCategories(prev => [...new Set([...prev, ...getCategoryIds(category)])]);
    } else {
      setSelectedCategories(prev => prev.filter(id => !getCategoryIds(category).includes(id)));
    }
    setCurrentPage(1); // Reset to page 1 on category change
  };

  const selectAllCategories = () => {
    const updateTree = (categories) => {
      return categories.map(category => ({
        ...category,
        isChecked: true,
        children: category.children ? updateTree(category.children) : []
      }));
    };
    
    setCategoryTree(updateTree(categoryTree));
    
    const allCategoryIds = getAllCategoryIds(categoryTree);
    setSelectedCategories(allCategoryIds);
    setCurrentPage(1); // Reset to page 1
  };

  const deselectAllCategories = () => {
    const updateTree = (categories) => {
      return categories.map(category => ({
        ...category,
        isChecked: false,
        children: category.children ? updateTree(category.children) : []
      }));
    };
    
    setCategoryTree(updateTree(categoryTree));
    setSelectedCategories([]);
    setCurrentPage(1); // Reset to page 1
  };

  const renderSearchMessage = () => {
    if (!searchTerm) return null;
    return (
      <div className="search-results-message">
        Showing results for: <strong>"{searchTerm}"</strong>
        <button 
          onClick={() => setSearchTerm("")} 
          className="clear-search-btn"
        >
          Clear search
        </button>
      </div>
    );
  };

  return (
    <section className="flat-spacing-1">
      <div className="container">
        <div className="tf-shop-control grid-3 align-items-center">
          <div className="tf-control-filter">
            <div className="btn-sidebar-style2">
              <button 
                data-bs-toggle="offcanvas" 
                data-bs-target="#sidebarmobile" 
                aria-controls="sidebarmobile"
              >
                <i className="icon icon-sidebar-2"></i>
              </button>
            </div>
          </div>
          <ul className="tf-control-layout d-flex justify-content-center">
            <li className="tf-view-layout-switch sw-layout-2" data-value-grid="grid-2">
              <div className="item">
                <span className="icon icon-grid-2"></span>
              </div>
            </li>
            <li className="tf-view-layout-switch sw-layout-3 active" data-value-grid="grid-3">
              <div className="item">
                <span className="icon icon-grid-3"></span>
              </div>
            </li>
            <li className="tf-view-layout-switch sw-layout-4" data-value-grid="grid-4">
              <div className="item">
                <span className="icon icon-grid-4"></span>
              </div>
            </li>
          </ul>
          <div className="tf-control-sorting d-flex justify-content-end align-items-center">
            <div className="tf-records-per-page mr-3">
              <label htmlFor="recordsPerPage" className="mr-2">Show:</label>
              <select
                id="recordsPerPage"
                value={recordsPerPage}
                onChange={handleRecordsPerPageChange}
                className="records-per-page-select"
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <div className="tf-dropdown-sort" data-bs-toggle="dropdown">
              <div className="btn-select">
                <span className="text-sort-value">{sortOrder}</span>
                <span className="icon icon-arrow-down"></span>
              </div>
              <div className="dropdown-menu">
                {[
                  "Featured",
                  "Price, low to high",
                  "Price, high to low",
                  "Alphabetically, A-Z",
                  "Alphabetically, Z-A",
                ].map((order) => (
                  <div
                    key={order}
                    className={`select-item ${sortOrder === order ? "active" : ""}`}
                    onClick={() => handleSort(order)}
                  >
                    <span className="text-value-item">{order}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="tf-row-flex">
          <aside className="tf-shop-sidebar wrap-sidebar-mobile">
            <SidebarContent 
              categoryTree={categoryTree}
              handleCategoryToggle={handleCategoryToggle}
              selectAllCategories={selectAllCategories}
              deselectAllCategories={deselectAllCategories}
              selectedCategories={selectedCategories}
            />
          </aside>
          <div className="tf-shop-content">
            {/* Add search results message */}
            {renderSearchMessage()}
            
            {currentRecords.length > 0 ? (
              <>
                {/* Pagination at Top */}
                {totalPages > 0 && (
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                  />
                )}
                <div className="grid-layout wrapper-shop" data-grid="grid-3">
                  {currentRecords.map((product) => (
                    <div key={product.productId} className="card Tari-product">
                      <div className="card-product-wrapper">
                        <Link to={`/productDetail?productId=${product.productId}`} className="product-img">
                          <img className="lazyload img-product" data-src={product.images[0]} src={product.images[0]} alt={product.name} loading="lazy" />
                          {/* {product.images.length > 1 && (
                            <img className="lazyload img-hover" data-src={product.images[1]} src={product.images[1]} alt={product.name} loading="lazy" />
                          )} */}
                        </Link>
                        {product.sizes && product.sizes.length > 0 && (
                          <div className="size-list">
                            {product.sizes.map((size) => (
                              <span key={size}>{size}</span>
                            ))}
                          </div>
                        )}
                      </div>
                      <div className="card-product-info">
                        <Link to={`/productDetail?productId=${product.productId}`} className="title link">
                          {product.name}
                        </Link>
                        {product.rateOfPiece !== "" && (
                          <div className="rate-of-piece">{product.rateOfPiece}</div>
                        )}
                        {product.discount && product.discount > 0 ? 
                        (
                          <div className="price-container">
                            <span className="price">
                              ₹{(product.totalPrice).toFixed(2)}
                            </span>
                            <span
                              className="price original-price"
                              style={{
                                textDecoration: "line-through",
                                color: "red",
                              }}
                            >
                              MRP: ₹{product.price.toFixed(2)}
                            </span>{" "}
                            <span className="discount-percent">
                              ({product.discount}% off)
                            </span>
                          </div>
                        ) : (
                          <span className="price">MRP: ₹{product.totalPrice.toFixed(2)}</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                {totalPages > 0 && (
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                  />
                )}
              </>
            ) : (
              <div className="no-products-found">
                <p>
                  {searchTerm
                    ? `No products found matching "${searchTerm}"`
                    : "No products found matching the selected categories."}
                </p>
                {selectedCategories.length === 0 && (
                  <button onClick={selectAllCategories} className="btn btn-primary">
                    Select All Categories
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
        {/* Offcanvas Sidebar for Mobile */}
        <div 
          className="offcanvas offcanvas-start" 
          tabIndex="-1" 
          id="sidebarmobile" 
          aria-labelledby="sidebarmobileLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="sidebarmobileLabel">Filters</h5>
            <button 
              type="button" 
              className="btn-close" 
              data-bs-dismiss="offcanvas" 
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <SidebarContent 
              categoryTree={categoryTree}
              handleCategoryToggle={handleCategoryToggle}
              selectAllCategories={selectAllCategories}
              deselectAllCategories={deselectAllCategories}
              selectedCategories={selectedCategories}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ShoppingList;